module.exports = __webpack_public_path__ + "img/guide.3a84c836.svg";